import { render, staticRenderFns } from "./updateStock.vue?vue&type=template&id=0ec2b82d&scoped=true&"
import script from "./updateStock.vue?vue&type=script&lang=js&"
export * from "./updateStock.vue?vue&type=script&lang=js&"
import style0 from "./updateStock.vue?vue&type=style&index=0&id=0ec2b82d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec2b82d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ec2b82d')) {
      api.createRecord('0ec2b82d', component.options)
    } else {
      api.reload('0ec2b82d', component.options)
    }
    module.hot.accept("./updateStock.vue?vue&type=template&id=0ec2b82d&scoped=true&", function () {
      api.rerender('0ec2b82d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rawmaterials/AddProduct/updateStock.vue"
export default component.exports